import { useQuery } from '@tanstack/react-query'
import { assetDetailExtrasApi } from '@/services/asset-detail-extras.service'
import { fileService } from '@/services/file.service'

/** React-query hooks for Asset Detail's stand-in panels. Version history and
 *  usage are still MOCK (no real backend); applicable-rules is real. */

export const useFileVersions = (fileId: string | null) =>
	useQuery({
		queryKey: ['file-versions', fileId],
		queryFn: () => assetDetailExtrasApi.versions(fileId as string),
		enabled: !!fileId,
	})

export const useFileUsage = (fileId: string | null) =>
	useQuery({
		queryKey: ['file-usage', fileId],
		queryFn: () => assetDetailExtrasApi.usage(fileId as string),
		enabled: !!fileId,
	})

export const useFileApplicableRules = (fileId: string | null) =>
	useQuery({
		queryKey: ['file-applicable-rules', fileId],
		queryFn: () => fileService.getApplicableRules(fileId as string),
		enabled: !!fileId,
	})
